import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthService} from '@mydocma/auth';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import swal from 'sweetalert2';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private token = 'Bearer' +
        ' eyJhbGciOiJSUzI1NiIsImtpZCI6IjUzMjE2MmYzYzliYzFiYmI3MmFmODBjZGU4OTE2NzAxIiwidHlwIjoiSldUIn0.eyJuYmYiOjE1NTQ5NzY4NjgsImV4cCI6MTU1NzU2ODg2OCwiaXNzIjoiaHR0cHM6Ly9hcGktdGVzdC5lZHItc29mdHdhcmUuY29tL215ZG9jbWEvbjIuMCIsImF1ZCI6WyJodHRwczovL2FwaS10ZXN0LmVkci1zb2Z0d2FyZS5jb20vbXlkb2NtYS9uMi4wL3Jlc291cmNlcyIsInBpeCIsInJlcG9ydCJdLCJjbGllbnRfaWQiOiJCYXlXYUFwcCIsInN1YiI6IkJheVdhQXBwIFVzZXIxIiwiYXV0aF90aW1lIjoxNTU0OTc2ODY3LCJpZHAiOiJsb2NhbCIsImRiX2lkIjoiMTFCRjMyRkYtRUFDOC00RTMyLTkxQjItRUE1NUNEMzhBMDY0IiwiZGJfc2NoZW1hIjoiUDM2MTIiLCJkYl91c2VyX2lkIjoiMTE1Iiwic2NvcGUiOlsicGl4IiwicmVwb3J0Il0sImFtciI6WyJwc3ciXX0.VLljt787ED9y_fxcrnCK-1-oPel9J9UvZqS1_qeJE0nGbmBQ9DekVHBOMWo-teyVO1GgKquKDIlSyXzmbvJcvBtFe9dcMhmnEeVuVozP2SDt8PUBrX0ucTS1J72YGNJFdvUeMqZH9XbRf0IVbNBtruu908niZkh9la38kAZyNqrmvTJ0YC3HSpXq29cXkd64Ui_XiDw-6N5HhXBhrJeKRINpJl84GemGpy_cfaFbeMLKH3OfYqZxfZNNVW8VGuwfqHZDx-kFA1l-G3KlSBRFGop7Prhn6sVKIiFVaDf8LXa0n5jCTQ1BXe4Vm0y5GIZyAl1BuMNgxrBqWPI94x9Lqg';

    constructor(private router:Router, private  spinner :NgxSpinnerService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(catchError(err => {
            if (err.status === 403 || err.status === 401) {

                this.router.navigate([''], {
                    queryParams: {
                        projectId: +localStorage.getItem('selectedProject'),
                        isLogout:true
                    }
                });
                const error =  err.statusText;
                return throwError(error);
            }else if( err>400 && err!=401){
                this.showSwal.show("Error",err.error,"error");
                this.spinner.hide();
            }

        }))
    }

    showSwal = {
        show: (title, text, type, fn?) => {
            swal({
                title: title,
                text: text,
                type: type,
            }).then((result) => {
            });
        }
    };
}
